import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_router_outlet = _resolveComponent("ion-router-outlet")!
  const _component_ion_app = _resolveComponent("ion-app")!

  return (_openBlock(), _createBlock(_component_ion_app, {
    dir: _ctx.direction,
    style: _normalizeStyle({ backgroundImage: `url(${_ctx.backgroundImage})` }),
    "data-html2canvas-ignore": "",
    onIonModalWillPresent: _ctx.pauseAudio,
    onIonModalWillDismiss: _ctx.pauseAudio,
    onIonActionSheetWillPresent: _ctx.pauseAudio,
    onIonWillOpen: _ctx.pauseAudio
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_router_outlet, {
        animated: true,
        animation: _ctx.fadeTransition
      }, null, 8, ["animation"])
    ]),
    _: 1
  }, 8, ["dir", "style", "onIonModalWillPresent", "onIonModalWillDismiss", "onIonActionSheetWillPresent", "onIonWillOpen"]))
}